import { CommanderStatusAPI } from '../api/CommanderStatusAPI';
import { COMMANDER_VOLATILE_DATA_POOLING_INTERVAL } from '../../api/Constants';
import { skipToken } from '@reduxjs/toolkit/query';
import { useAllDevices } from '../../hooks/useAllDevices';
import { useMemo } from 'react';

/**
 * Fetch statuses for all commanders and return a map by commanderId.
 * Safe to use unconditionally (no hooks-in-loops).
 */
function useCommandersStatuses(commanderIds: string[]) {
  const { data: devicesStructure } = useAllDevices();
  const allCommandersIds = devicesStructure?.result;

  const { data, ...rest } = CommanderStatusAPI.useGetCommandersStatusQuery(
    allCommandersIds ?? skipToken,
    {
      skip: !allCommandersIds?.length,
      pollingInterval: COMMANDER_VOLATILE_DATA_POOLING_INTERVAL,
    }
  );

  const statuses = useMemo(
    () =>
      commanderIds.map((id) => ({
        commanderId: id,
        commanderStatus: data?.entities[id],
      })),
    [data, commanderIds]
  );

  return { statuses, ...rest };
}

export default useCommandersStatuses;
